import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-basic-button_sync",
  "use": "icon-basic-button_sync-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"icon-basic-button_sync\"><g stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M17 11H3M7.753 15.913L3 11\" /><g><path d=\"M2.606 7.226h14M11.854 2.313l4.752 4.914\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol